
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ProductImageConnectionFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"ProductImageConnection"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"edges"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"node"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"alternateDescription"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"imageUrls"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"wideHorizontal"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"classicHorizontal"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"square"},"arguments":[],"directives":[]}]}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"phoenixShopFragmentMediaGallery"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"PhotoGalleryImageConnection"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hotelView"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductImageConnectionFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"suites"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductImageConnectionFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"guestRooms"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductImageConnectionFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"recreationAndFitness"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductImageConnectionFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"dining"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductImageConnectionFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"eventsAndMeetings"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductImageConnectionFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"features"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductImageConnectionFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"golf"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductImageConnectionFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"nearbyAttractions"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductImageConnectionFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"services"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductImageConnectionFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"spa"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductImageConnectionFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"villas"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductImageConnectionFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"activities"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductImageConnectionFragment"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"weddings"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ProductImageConnectionFragment"},"directives":[]}]}}]}}],"loc":{"start":0,"end":1097}};
    doc.loc.source = {"body":"fragment ProductImageConnectionFragment on ProductImageConnection {\n  edges {\n    node {\n      alternateDescription\n      title\n      imageUrls {\n        wideHorizontal\n        classicHorizontal\n        square\n      }\n    }\n  }\n}\n\nfragment phoenixShopFragmentMediaGallery on PhotoGalleryImageConnection {\n  hotelView {\n    ...ProductImageConnectionFragment\n  }\n  suites {\n    ...ProductImageConnectionFragment\n  }\n  guestRooms {\n    ...ProductImageConnectionFragment\n  }\n  recreationAndFitness {\n    ...ProductImageConnectionFragment\n  }\n  dining {\n    ...ProductImageConnectionFragment\n  }\n  eventsAndMeetings {\n    ...ProductImageConnectionFragment\n  }\n  features {\n    ...ProductImageConnectionFragment\n  }\n  golf {\n    ...ProductImageConnectionFragment\n  }\n  nearbyAttractions {\n    ...ProductImageConnectionFragment\n  }\n  services {\n    ...ProductImageConnectionFragment\n  }\n  spa {\n    ...ProductImageConnectionFragment\n  }\n  villas {\n    ...ProductImageConnectionFragment\n  }\n  activities {\n    ...ProductImageConnectionFragment\n  }\n  weddings {\n    ...ProductImageConnectionFragment\n  }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["ProductImageConnectionFragment"] = oneQuery(doc, "ProductImageConnectionFragment");
        
        module.exports["phoenixShopFragmentMediaGallery"] = oneQuery(doc, "phoenixShopFragmentMediaGallery");
        
